
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edoAC5zfmaR2d3VnKKKPLlfl2MeoAIAKC_asI5tsZE1kDsMeta } from "/var/www/2025-11-05_17_57/pages/edo.vue?macro=true";
import { default as helpjDr7KtMI6lBToTrEK2D2T1f_45EtMGkSlhhWUlNkfoVW8Meta } from "/var/www/2025-11-05_17_57/pages/help.vue?macro=true";
import { default as cargoQSw_45eNvR9WI8_4531mI1V_Fku0hwvCFdg7o4fiKugbbsEMeta } from "/var/www/2025-11-05_17_57/pages/cargo.vue?macro=true";
import { default as indexmibj3PdsCVjH_luDDV2nxGY1gPWBeEwq_45qpLpMnm4QsMeta } from "/var/www/2025-11-05_17_57/pages/index.vue?macro=true";
import { default as _91slug_93HkBnkZBtjFDJ_45DbWUSVB2V0XdxEkpLWRa49ZOv6BO9oMeta } from "/var/www/2025-11-05_17_57/pages/[slug].vue?macro=true";
import { default as cookieZ0FceI9IDIBR_45W0WNIgmecWBXbeGN35FbVrq6p6KgbEMeta } from "/var/www/2025-11-05_17_57/pages/cookie.vue?macro=true";
import { default as survey4o0iWYJ38bCn7XYIE4iwa9Mx_UPimTSKmEUgMh_45lJEEMeta } from "/var/www/2025-11-05_17_57/pages/survey.vue?macro=true";
import { default as belarusxessbYyVfM4Wg72Byq_X4D8lba_06mTqDtGho_zL1fAMeta } from "/var/www/2025-11-05_17_57/pages/belarus.vue?macro=true";
import { default as bonusesKmjx9vRPjMFfsaOsCBel_VBwANTlDhIW11d_1AcI6F4Meta } from "/var/www/2025-11-05_17_57/pages/bonuses.vue?macro=true";
import { default as apimXQI9Agixg5yFsHUgmvJgCfJggeM__RhS94E85HvJrkMeta } from "/var/www/2025-11-05_17_57/pages/dev/api.vue?macro=true";
import { default as cmsjQx8dOb6E7_6CTN4qdD04YztCm9VxTx5LJ_45bCW9eGb0Meta } from "/var/www/2025-11-05_17_57/pages/dev/cms.vue?macro=true";
import { default as konkursSWUdl_dJsEyPfPYCfvQtmqlML20pgrmq4b5bZ1xGY8YMeta } from "/var/www/2025-11-05_17_57/pages/konkurs.vue?macro=true";
import { default as successNbNSl8YAXxIRWqaq5kmTQrbh0ma_45qP7Fj5HJ8v2Pp_45kMeta } from "/var/www/2025-11-05_17_57/pages/success.vue?macro=true";
import { default as vacancyOcrKm9u_bw6waiDtScdZ213cO_45h1HEOdJTINDu5Q3RgMeta } from "/var/www/2025-11-05_17_57/pages/vacancy.vue?macro=true";
import { default as contactsnyTnu4uJ5VB3olr2E9rkecWHwMv7VH951mcWCm8rI8cMeta } from "/var/www/2025-11-05_17_57/pages/contacts.vue?macro=true";
import { default as giveawaynNZHh3TAgDV9yWQBXRD_45JTVCpbk350DwfZHMw6NTkeMMeta } from "/var/www/2025-11-05_17_57/pages/giveaway.vue?macro=true";
import { default as guide_45lkxeBbfKK_Ub2Es3PtyWNC0ecvSZE9zbBLfDYhjEIRqSAMeta } from "/var/www/2025-11-05_17_57/pages/guide-lk.vue?macro=true";
import { default as serviceshciZ27OJf1pHGFv0mTDrkFzc5qanR1cMbHh_45aHSYuiwMeta } from "/var/www/2025-11-05_17_57/pages/services.vue?macro=true";
import { default as telegramwuLraicvBpFkERf_RSUaZ5r1lZztm90q8i2RyO5sXhgMeta } from "/var/www/2025-11-05_17_57/pages/telegram.vue?macro=true";
import { default as documentssG3rLlgzEsyS0AuJ6RKMAqI4q_fXucRwXkMeNub9EO4Meta } from "/var/www/2025-11-05_17_57/pages/documents.vue?macro=true";
import { default as franchise0GYSIXzKQ_45eKD75Rc5oZJNDNLjJ3D0s5gh_45UV7DNZtQMeta } from "/var/www/2025-11-05_17_57/pages/franchise.vue?macro=true";
import { default as insuranceVt3l27o9JYIWjOmDnuQboCElf8_Bpr7dimQQXq_fSnwMeta } from "/var/www/2025-11-05_17_57/pages/insurance.vue?macro=true";
import { default as kirghiziaHBPJ5mNDP0G7x5bTpZiDv3a5ET4H3R4Mcb1_laVpNfoMeta } from "/var/www/2025-11-05_17_57/pages/kirghizia.vue?macro=true";
import { default as mapSchemeYBJmKk9m5_457Oq5H2_45OYcdX_45TqTsIXChjpCJ3oB6wYrkMeta } from "/var/www/2025-11-05_17_57/pages/mapScheme.vue?macro=true";
import { default as _91id_93_45LM_dbZlf0ZEKLAJXmIXAvimK3qiiDot3ZBCLm6Up1cMeta } from "/var/www/2025-11-05_17_57/pages/news/[id].vue?macro=true";
import { default as return_45sdHXouXBqhYdogIq1dn0KYREgODaqFNvPUCa1l0RE7PQMMeta } from "/var/www/2025-11-05_17_57/pages/return-sd.vue?macro=true";
import { default as smsClientK_45HZGXVqhSFbASuK3NtKFpp_PMJyhNYYpj9jZamJ7X8Meta } from "/var/www/2025-11-05_17_57/pages/smsClient.vue?macro=true";
import { default as terminalsmCL9WT4GYKr3fH3tKe2Sw69FTyFNvIUShaFx_A1g4w8Meta } from "/var/www/2025-11-05_17_57/pages/terminals.vue?macro=true";
import { default as iframeyzd9kWVqFv6NOAww3CQnDkll_XPAAzCrNxDExLyNFUIMeta } from "/var/www/2025-11-05_17_57/pages/dev/iframe.vue?macro=true";
import { default as directionsFbvc7bi60A72fXLW2C0I4ox0GvDcB5dUd4n52hZ11LoMeta } from "/var/www/2025-11-05_17_57/pages/directions.vue?macro=true";
import { default as kazakhstanoF6_45Ch32mqrSju88VNyBgdTK1ZA26TfeNWlmvEpjZiUMeta } from "/var/www/2025-11-05_17_57/pages/kazakhstan.vue?macro=true";
import { default as indexdpdttnTFGKrXu4xnB4bPmcqn9tElFHKXdRRN1hQLOnYMeta } from "/var/www/2025-11-05_17_57/pages/news/index.vue?macro=true";
import { default as svgbjqHqjF71o3yQU1NHkpla08kCj55M2mFLorB_457mtLwIMeta } from "/var/www/2025-11-05_17_57/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45fail77fxyEKy_MrRDykue41_45C994GymGaU6Lz36R1PMxTaEMeta } from "/var/www/2025-11-05_17_57/pages/vzpay-fail.vue?macro=true";
import { default as constructorCycz3n5iI5JC6gUqI6LBWZ6ri6pz__45CwEmGbAgE133EMeta } from "/var/www/2025-11-05_17_57/pages/constructor.vue?macro=true";
import { default as index2E0L7WlBl4Xe8KTOGgS8osoAswUQ3etpulSRn8OGzC8Meta } from "/var/www/2025-11-05_17_57/pages/gifts/index.vue?macro=true";
import { default as informationnTSEvqEC8NslL_45BpGhoLro_45FgeG9JqhX3QDhhc8SYmcMeta } from "/var/www/2025-11-05_17_57/pages/information.vue?macro=true";
import { default as claim_45filinghUnrxCwESAgREEB8HZ81sx_452wnNG7SogN1Md6tG_9g8Meta } from "/var/www/2025-11-05_17_57/pages/claim-filing.vue?macro=true";
import { default as _91type_93SE0_450yn7sPyMOAOBXpYneEIaFLppjHnjpEBpRhDs_JUMeta } from "/var/www/2025-11-05_17_57/pages/gifts/[type].vue?macro=true";
import { default as marketplacesoLbPbOh00_Z37rtOVOAJNIBGnwcGtyhgVHqBP12FAPwMeta } from "/var/www/2025-11-05_17_57/pages/marketplaces.vue?macro=true";
import { default as networkshopspKA2vXftNbeDIFC8Mh_QdPiRxELMUzG79Ntt_4545WNVUMeta } from "/var/www/2025-11-05_17_57/pages/networkshops.vue?macro=true";
import { default as online_45storeJleHj0i1fHlc1mP663SVICo7qpFdTjeG9oWoxmRQpSAMeta } from "/var/www/2025-11-05_17_57/pages/online-store.vue?macro=true";
import { default as manageo6p_vhBPcq4aRhKJ_KP1I4_sfrlnnyI3N2BfW9JJQvUMeta } from "/var/www/2025-11-05_17_57/pages/order/manage.vue?macro=true";
import { default as registration_ULxGGA7aiKr_hRf7QbUqHpJwEQ0IaQImw0yDg0rlQAMeta } from "/var/www/2025-11-05_17_57/pages/registration.vue?macro=true";
import { default as safe_45custodyeiR_R0waRMGqthoqA6FHOBvyKM6b5N8U__45SKAEn2L3sMeta } from "/var/www/2025-11-05_17_57/pages/safe-custody.vue?macro=true";
import { default as imageZKJ0pqFlzcbrW6YUuL1ZEsT2J9UNOBwGtbbZe_IeVucMeta } from "/var/www/2025-11-05_17_57/pages/ui-kit/image.vue?macro=true";
import { default as indexVk_45D9tebH37luGb2MWlmK52fjbuyAbZ_4AtTYOS4rCMMeta } from "/var/www/2025-11-05_17_57/pages/ui-kit/index.vue?macro=true";
import { default as bag_UmHkpryEkjUYsE9LyDFIM1myPq63x9WA_PdflSni3cMeta } from "/var/www/2025-11-05_17_57/pages/wrapping/bag.vue?macro=true";
import { default as boxw0k52kPok6jlHDuCU3b4nTurBUKzVSQjIxmxKiaROBYMeta } from "/var/www/2025-11-05_17_57/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loadingcU5buuQ5zm__ZUzKUNgJqZd6Cl7BqXIW2U6_VFVslT4Meta } from "/var/www/2025-11-05_17_57/pages/cargo-loading.vue?macro=true";
import { default as happybirthdayJGu3lPMjGezzqWeZvD6gFdiUvS8qMnMkvcJyUzlLXEcMeta } from "/var/www/2025-11-05_17_57/pages/happybirthday.vue?macro=true";
import { default as manageAZXhvMsiSz2JACwIZKKhr4KgsszXRsuPH8Pe_sht0xUMeta } from "/var/www/2025-11-05_17_57/pages/iframe/manage.vue?macro=true";
import { default as authg_JUdtaCFtlEOGXA22bRe9qLAWwiH31ZfTwGi3jDSEEMeta } from "/var/www/2025-11-05_17_57/pages/personal/auth.vue?macro=true";
import { default as indexc9JSE6Prmac7b4_zY2kkBkR2SxQGMeS9MHYL_45CoxgvkMeta } from "/var/www/2025-11-05_17_57/pages/tariffs/index.vue?macro=true";
import { default as publicLwR3K_ckl5owCHnPc05ez29vmnEQRxGaw0Ih8e0Nw7sMeta } from "/var/www/2025-11-05_17_57/pages/ui-kit/public.vue?macro=true";
import { default as already_45answer_t_45Ef6a9sR6mq8pz3cZMhL_6FJ6CWSj1scBdIU74WV8Meta } from "/var/www/2025-11-05_17_57/pages/already-answer.vue?macro=true";
import { default as tariffsmnGWn60AGjcNruz__a7RPNuqCucZFy_45G4Nu846w47pYMeta } from "/var/www/2025-11-05_17_57/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_93tyLmKaQBMQrepXy9hnk12F1lcHeXcwNeSF17NtAuhRsMeta } from "/var/www/2025-11-05_17_57/pages/order/pay/[id].vue?macro=true";
import { default as indexYnOXJCPo6UEUS8xWDYqKFEMYIxF_TJhFWfC5A_45b10VoMeta } from "/var/www/2025-11-05_17_57/pages/personal/index.vue?macro=true";
import { default as privacy_45policybkuwppd7zC_pamf1qgfUq7bVjBV8K51C7BgQ8kgdKqwMeta } from "/var/www/2025-11-05_17_57/pages/privacy-policy.vue?macro=true";
import { default as _91hash_931tPi3jWWxhJr3I31nf3WdFsreEDCygs7On1XsNLGnIoMeta } from "/var/www/2025-11-05_17_57/pages/welcome/[hash].vue?macro=true";
import { default as index7ivxk8wlwdAowyreIP_45Ra0tLmKzDNLqtKClUGMRYQWEMeta } from "/var/www/2025-11-05_17_57/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russiay0lB_PIyzJINRk1Rql2m03tsV1JtUwH8Yvg_45eAKIH6oMeta } from "/var/www/2025-11-05_17_57/pages/delivery-russia.vue?macro=true";
import { default as payment_45methodsAKlaIMUug50j_FHjuDDW6YHtVEkFzDz3ZWim5xncWnIMeta } from "/var/www/2025-11-05_17_57/pages/payment-methods.vue?macro=true";
import { default as qr_45infoyG8avzocLyZhpljA1_45hXbfd1cVyPAp3GO5TnBHbs8xEMeta } from "/var/www/2025-11-05_17_57/pages/payment/qr-info.vue?macro=true";
import { default as successEJMlYWtsirotIa6_jX8U_2MTylEEdy9xOzm1eWzHiiYMeta } from "/var/www/2025-11-05_17_57/pages/payment/success.vue?macro=true";
import { default as importN_6Ta_45xMluZdXPD2H9ykl_dQeuCNV6A91_LcXn__45tkgMeta } from "/var/www/2025-11-05_17_57/pages/personal/import.vue?macro=true";
import { default as logoutUczFkPz_45YuqY5yyEAmGN13qBn6upmkVRbp0u1jp1yQYMeta } from "/var/www/2025-11-05_17_57/pages/personal/logout.vue?macro=true";
import { default as address_45deliveryp9BxTg5zzyJxM7eznRFrnJ587ZFlj472vq0HdBaBBkEMeta } from "/var/www/2025-11-05_17_57/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45deliveryn5n4Xqcu3SzMRYbKRHXCow7l29f999MGpj_z5S6fWf4Meta } from "/var/www/2025-11-05_17_57/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear20241gT9ibkMa28Z6Npx4S9yj_45eOaYn6CyuDUnRSyo_45WadAMeta } from "/var/www/2025-11-05_17_57/pages/happynewyear2024.vue?macro=true";
import { default as ozonPO7cwHH8_45y_GJi6y10wDO7_bTGB1Vf6lnzHnpz_45xdsAMeta } from "/var/www/2025-11-05_17_57/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45fail8xt9GElGvTCGvCYN_0Phth3cpy0XnQHEGX8IcYJ6QGIMeta } from "/var/www/2025-11-05_17_57/pages/payment/pay-fail.vue?macro=true";
import { default as accountaRLh7kWWFMrz5QD7UOwH3Ln2zQMEFR0zVdMug2QvQckMeta } from "/var/www/2025-11-05_17_57/pages/personal/account.vue?macro=true";
import { default as prohibited_45goods6wJ_tuPNoL0j6UfKYOWey_45w7yUW_FaH5tJe0tU6B_45JEMeta } from "/var/www/2025-11-05_17_57/pages/prohibited-goods.vue?macro=true";
import { default as survey_45completedwAB7qepLmw5Mr9TnHVwoBUn2bfY6jUgDlOU_45yiuklzYMeta } from "/var/www/2025-11-05_17_57/pages/survey-completed.vue?macro=true";
import { default as directionzREU7tPrsTBdpFs_ryVj56wro4kbjHnFVRGS0z21B7QMeta } from "/var/www/2025-11-05_17_57/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupGVXznlvcpgvDsm_GDg2SaYT1akbH0nglYZzBvUH1IV8Meta } from "/var/www/2025-11-05_17_57/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargoHlmTnqa_45Z1DWQVtWV0LKTqFfNOASpr6B50oiZ0uSkUgMeta } from "/var/www/2025-11-05_17_57/pages/free-pickup-cargo.vue?macro=true";
import { default as calculatorQpU3JMQwH9rSOb0CEpQsA6Ly_cSV1GrAjlbRVWbdNOcMeta } from "/var/www/2025-11-05_17_57/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonusesLRzMl9BdoaysSHYEyM53hpb4UWs6Hfky1xCzEB7JjEwMeta } from "/var/www/2025-11-05_17_57/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_938YrWjIANbZ4FsXybcg5KpCYWlOnHiww90KFNo_Bfm2QMeta } from "/var/www/2025-11-05_17_57/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45info7PvITSckqE4133NotFprQBY2bF5e_45Mwg9K7XeMKOHtIMeta } from "/var/www/2025-11-05_17_57/pages/payment/card-info.vue?macro=true";
import { default as discount10LXy0xTiQMDRx7d1riXYwr3MCUleqcp01NVJQiYpkoMeta } from "/var/www/2025-11-05_17_57/pages/personal/discount.vue?macro=true";
import { default as hard_45boxzgSIYucQbNdvNMo2MHmuH6bhrRDxmIVqgwjhr_aONisMeta } from "/var/www/2025-11-05_17_57/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receiptOWoTPmFDLFzdZGKmWiIpB_45ENfY8LsjlQhwEL2bWaagoMeta } from "/var/www/2025-11-05_17_57/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient10201917GeBxoP26__2pcxvJmmBbjjH2Lna7SmYcxNfHzoSD4BUMeta } from "/var/www/2025-11-05_17_57/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45application3PLO4Erz43DSRWB8XM858EpscPEYyroLaeA6K5z36AwMeta } from "/var/www/2025-11-05_17_57/pages/mobile-application.vue?macro=true";
import { default as indexXVZZE6X5rIUqFdgu6R5xgDBWNgL20A0H_45otHbOdrL9wMeta } from "/var/www/2025-11-05_17_57/pages/order/create/index.vue?macro=true";
import { default as indexqU3Wx4f54GZBHsJ0IgEFCXX_45T_45LbFak9ncHUDi_auQ4Meta } from "/var/www/2025-11-05_17_57/pages/run-schedule/index.vue?macro=true";
import { default as boatTmWS34FYpD5L26Ho2e7CoSMZaFJCFrpbmFeQ1WWih0QMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/boat.vue?macro=true";
import { default as sofapTZww9bntgLsGt3jTzPqd0cRgpncWuIv8pfl2C9WtBkMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/sofa.vue?macro=true";
import { default as _91location_93owIoLuKaycBTiGKBua0L0A5_NGI4qpR8mf0IWKaXYg8Meta } from "/var/www/2025-11-05_17_57/pages/tariffs/[location].vue?macro=true";
import { default as cardboard5gEN5djHhf80Zs_vJGM0q_TftEoqxiK2f0k0NcQQxRQMeta } from "/var/www/2025-11-05_17_57/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodesdrHadFbMVTSPiJJ2ZDq1GzEImuvet_WJLumG4cFhRB4Meta } from "/var/www/2025-11-05_17_57/pages/personal/promocodes.vue?macro=true";
import { default as benchvy9LZ2E_450lUpweg4dTWugbDRRuN1BCtwOsalt9DM_ooMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/bench.vue?macro=true";
import { default as booksIx0mHVklTLvxN_lYgmWJZpEb7NUD4tkweyr9gLkdJyQMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/books.vue?macro=true";
import { default as cablefiNiJRQqVEBaakPIOeHuBQGeB39dq8nqgdaKL4wvXckMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/cable.vue?macro=true";
import { default as chairs3chAbaozZE_45cSlkNnmKVSP_45_45vyOHFuQveoT1ECyydgMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/chair.vue?macro=true";
import { default as goodssJ6nPmKovCHgaFC5HimYTjzqjqXwg_KLaZNmvaEI2cMMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/goods.vue?macro=true";
import { default as indexcka4h2N5UH3jgWMHfKCGleo2CmBzrbwcpnahBXzDQXwMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/index.vue?macro=true";
import { default as metal29ejbtxQovTTIMfO4xL3esBvlAKOBZhpBSerdfFmKwgMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/metal.vue?macro=true";
import { default as piano9Jua3MFg4BpUnT_SIMnQkhXryRVbPNyK2xRHxhOyr9sMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/piano.vue?macro=true";
import { default as pipeswc4uzCnxoyXPxPHfr11SUV6qwL29JPSYKBWsl0C4Z7cMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/pipes.vue?macro=true";
import { default as toolsUZq1wECsY_455yTZFuzzXkUmntH_lYLb0av7WhFMdSQHQMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45boxiqwKcMaGwmSn1NoJIfP5G8Ag1BueZVvvKovVOnuMZJQMeta } from "/var/www/2025-11-05_17_57/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_93AeJELEAj5taPbSHhWiWycomPvUQawSaOJKB4RUkDoccMeta } from "/var/www/2025-11-05_17_57/pages/personal/bonus/[tab].vue?macro=true";
import { default as printgSP_w_45Qvyog6MlaS0UjP0FybH2DHS8Q_45swHL9bih_ogMeta } from "/var/www/2025-11-05_17_57/pages/personal/order/print.vue?macro=true";
import { default as dishese0SF821TCzF0buD5WLftH1DPNoSNwuOvXwCh_y3rDMsMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/dishes.vue?macro=true";
import { default as engineI0bNhSjLFZgqttKXYenGuDK4ljW_45h5ZvMcKnzhKVVsoMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/engine.vue?macro=true";
import { default as lumber1k9CYvw7da48Qq2gao0qpJPhphdErBDr3cszygKpK64Meta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheelsvd6W7liiwT_jbdQ1z0mjHKbIKGvC3uGect0_45BNPBJjYMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45filmsTdUGNCKTlvy1g1PyuzgXdBEx3oq2DC43kfUfVVsj08Meta } from "/var/www/2025-11-05_17_57/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletisingSaAsc4O54R4SfIS385oswuEJ9Xiwv9DMqwhhEvRBAYcMeta } from "/var/www/2025-11-05_17_57/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capitalB_45pZ2w_Zl3ZrnlmzqU0X9Jsf6xC02QcSitzldviQ1H4Meta } from "/var/www/2025-11-05_17_57/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_93gRswOzy6pFrGP29UkF15ouPDmHKCHMkwvqaYIk9HFjcMeta } from "/var/www/2025-11-05_17_57/pages/personal/order/[guid].vue?macro=true";
import { default as createWp3nxuXntzpKfDk3J5IwrThE2bdgmuNk_45wRYoNACO54Meta } from "/var/www/2025-11-05_17_57/pages/personal/order/create.vue?macro=true";
import { default as indexPLc4XDTGg0JioeoosPhLrGniHKNndyeEJ1lCgEd807EMeta } from "/var/www/2025-11-05_17_57/pages/safekeep/create/index.vue?macro=true";
import { default as barrelslfe50Rb5Ex_Rl9PymI9_1JeuvK_45uqHZNN7zYk6vogsUMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothesLW9452elB4yV2sSmP2jcu1Ltk7Pue_0wDVMH48i_453SYMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragileXIZ1OmSxaEDld7R608r97w9I42NRZWgMFQlZvGl9MGcMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailerEu2QEWmrNWher1Gv9JQdeI2F5A9XQG4bHVbEw2Cq6h4Meta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45packagetrND4eljvmHcXGuntpAcLQwZ7OYe_45vkMk9G9WLCQlzAMeta } from "/var/www/2025-11-05_17_57/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45successcVkoDjOOQK5qfS9qr_45BiuUw5TgKr6Zj4qxcoi_45vnCe4Meta } from "/var/www/2025-11-05_17_57/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45packageKuLaOHKWqpCrmsAiqmnYv0c2IUUfnK2lcf3c23aDfEoMeta } from "/var/www/2025-11-05_17_57/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberries4vJj4UaUufE8HKKSUfG3SyIbjv_5t5qPZU84VK8bLG4Meta } from "/var/www/2025-11-05_17_57/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_93BZAZHtnqd_2eVbvhKTL6TJNMcgg2VoC_45RiJn0PBOAZoMeta } from "/var/www/2025-11-05_17_57/pages/order/administer/[guid].vue?macro=true";
import { default as _91location_93WwGObEWVEGD4nt5CrQ9UA5Lu9jTEpexnNFoGqC_2vbYMeta } from "/var/www/2025-11-05_17_57/pages/run-schedule/[location].vue?macro=true";
import { default as furnitureAHQrYGQxdnD_ik_45g02h2rZvf3HMhvZIqpOqOYJmSDVYMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversizedjABKCPqqaTdYr5ZMhT9asfTjaB_45ENYFROV76HozMHoQMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45bikeyDZXxQMXrkzy1juyRQnxUA5oDXy85dGm6WUMD1PpvUYMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_93uGEnuCIxig5ejqMU6OziwvlEOQb3viZX9C6wFHo2c5wMeta } from "/var/www/2025-11-05_17_57/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_93pUy98kAZZqImCY_fK43WSUkOvW2lJaeTaET1MQ7qD6sMeta } from "/var/www/2025-11-05_17_57/pages/personal/orders/[...tab].vue?macro=true";
import { default as _91guid_93FODlO_PvSA7wPQNO4aJTnRkJJ3xGxnfl4ziXgnPHeZ0Meta } from "/var/www/2025-11-05_17_57/pages/personal/safekeep/[guid].vue?macro=true";
import { default as createifsqgYJPjQlfUuoChTVzWlLVjFqUWFzgL1xZdU9PCn4Meta } from "/var/www/2025-11-05_17_57/pages/personal/safekeep/create.vue?macro=true";
import { default as auto_45partstW35lxfgF2aof3Ej8ApjQ9RWVI4TTpNg8SrQjS15ZK4Meta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspapersw0A4jug7EpZBRnT_5_7gyAIR33e62YzbECBXxFrjLLEMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargo37lDUBs9Au9KgHkO2WFbO6_Iv_45Rt_ZNyp_gwxLXfrXAMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobilevaty9lgW3JmMJNFm_CBwcvxTn5F6tZ1ccFXpeQttxwAMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as indexwqLPSXH8w9FkCKFfdEpRh4RpkKlEUEE_45UOORKUT8lEwMeta } from "/var/www/2025-11-05_17_57/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45marketSVsdbhA2dg7_FIthJuS5JJ3CTG3M6UbtAO4YsVcsOI8Meta } from "/var/www/2025-11-05_17_57/pages/marketplace/yandex-market.vue?macro=true";
import { default as templatesRHTLps1ellWj9i2ssOgmSs8ZFtkZQ6PE922xWK5LSJsMeta } from "/var/www/2025-11-05_17_57/pages/personal/orders/templates.vue?macro=true";
import { default as index7WdNMOk04aJcUAXVFeoqt6PFadnZUbswLYF1dSQeHcoMeta } from "/var/www/2025-11-05_17_57/pages/personal/contractors/index.vue?macro=true";
import { default as _91guid_93gMBGkfgucQ3iri1wJ7jU3hv96tEDanfcMDUjlHv8HzgMeta } from "/var/www/2025-11-05_17_57/pages/personal/order-ozon/[guid].vue?macro=true";
import { default as _91guid_93zmxLCn9J6gfKrIYo41UfQrsX_45Gn3__yOBlPwSCBTQZIMeta } from "/var/www/2025-11-05_17_57/pages/safekeep/administer/[guid].vue?macro=true";
import { default as refrigeratorFQD86PH9bDK_45rllbN8VBEltde6r1KvjQobUmM6xqAdwMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93ugRuNCDRdrbg74j9Gz4bsuacO9I_wL9K6v1TCHESGWoMeta } from "/var/www/2025-11-05_17_57/pages/personal/contractors/[guid].vue?macro=true";
import { default as indexBjbBki_45NPymKRphf1IGdrVbVeDfgMQWZFvrMcmjILcEMeta } from "/var/www/2025-11-05_17_57/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91_46_46_46tab_93X_KAcsaZS8pB4MjNhgTP1CiEQeE1RWPBxkF0YKQFT4cMeta } from "/var/www/2025-11-05_17_57/pages/personal/safekeeps/[...tab].vue?macro=true";
import { default as _91guid_93IjbKXcY0cEGAlO7sgdwJJe7aZOXIc_uhQVhwiV0to7QMeta } from "/var/www/2025-11-05_17_57/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goodsQ_Oz7Sxjjk_454lwMuNmsxrgI9U998_45C0KOv7GIViLuf8Meta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as indexvDWH3gFaaZAMZK47RvmtI8dHvf6cimCZ1VpLz5NFbSYMeta } from "/var/www/2025-11-05_17_57/pages/personal/group-printing/index.vue?macro=true";
import { default as index_4553FyWRGgu_V9ZDulbFucgiwaTG656MHWbxTKgxanz0Meta } from "/var/www/2025-11-05_17_57/pages/personal/multi-delivery/index.vue?macro=true";
import { default as _91_46_46_46tab_93RaQpApDOzLGsSI0RXIZEg_DyUmBQg9vMQzhxEbsg5HgMeta } from "/var/www/2025-11-05_17_57/pages/personal/orders-ozon/[...tab].vue?macro=true";
import { default as medical_45devicesjHP3PQ_64IAl93TaYwfob4vyEgjKcDxfgnzZN27cAfEMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_93_459dCjMdkxZe3H7X8MTw3aqdkZ9raPFXyhtz_oyXGE6sMeta } from "/var/www/2025-11-05_17_57/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93THHeGYbIlF8CfsiBFKOV9oz4AqOV_tTZIGOV8sH_45uYEMeta } from "/var/www/2025-11-05_17_57/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_93QhdhzWNw7x02AjQimgRgaKbX3LT9dSCjUq1lFu9biyMMeta } from "/var/www/2025-11-05_17_57/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipmentoxxMGGYu1_45hEzQ9Wpy3IfUImvu5s9r3GGLEuK96v87QMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materialsGLwTcswBAnDo2vucctcAQlTUjWwj17d4RXt0r6iUfikMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instrumentsyTIfk_NUI1wHpdhRCppsJwng4nuc7sNk36uKLB7q5QkMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipmentHl2sXqbuViBteUHiFktR8DPrfWSVvyVJdUUy5zN6v_450Meta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportationgwC7VkU8LCM4ZEOHYJjWpbecjaqlTuqCJibQO7p3elsMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_93Vp4MY0eLf897VV0WTkC5D_45_D30lAK_nHaqfQOLn8biQMeta } from "/var/www/2025-11-05_17_57/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportation5HwubyvhdeVVPHpgB8RWRVKTRNH913rtip5q7pOD1XIMeta } from "/var/www/2025-11-05_17_57/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-11-05_17_57/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-11-05_17_57/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-11-05_17_57/pages/cargo.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-11-05_17_57/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93HkBnkZBtjFDJ_45DbWUSVB2V0XdxEkpLWRa49ZOv6BO9oMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/[slug].vue")
  },
  {
    name: "cookie",
    path: "/cookie",
    component: () => import("/var/www/2025-11-05_17_57/pages/cookie.vue")
  },
  {
    name: "survey",
    path: "/survey/:surveyId/",
    meta: survey4o0iWYJ38bCn7XYIE4iwa9Mx_UPimTSKmEUgMh_45lJEEMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/survey.vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-11-05_17_57/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-11-05_17_57/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-11-05_17_57/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-11-05_17_57/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkursSWUdl_dJsEyPfPYCfvQtmqlML20pgrmq4b5bZ1xGY8YMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-11-05_17_57/pages/success.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-11-05_17_57/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contactsnyTnu4uJ5VB3olr2E9rkecWHwMv7VH951mcWCm8rI8cMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-11-05_17_57/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-11-05_17_57/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-11-05_17_57/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-11-05_17_57/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-11-05_17_57/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-11-05_17_57/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-11-05_17_57/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-11-05_17_57/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapSchemeYBJmKk9m5_457Oq5H2_45OYcdX_45TqTsIXChjpCJ3oB6wYrkMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93_45LM_dbZlf0ZEKLAJXmIXAvimK3qiiDot3ZBCLm6Up1cMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-11-05_17_57/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-11-05_17_57/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-11-05_17_57/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-11-05_17_57/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-11-05_17_57/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-11-05_17_57/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: indexdpdttnTFGKrXu4xnB4bPmcqn9tElFHKXdRRN1hQLOnYMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-11-05_17_57/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-11-05_17_57/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructorCycz3n5iI5JC6gUqI6LBWZ6ri6pz__45CwEmGbAgE133EMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: index2E0L7WlBl4Xe8KTOGgS8osoAswUQ3etpulSRn8OGzC8Meta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-11-05_17_57/pages/information.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-11-05_17_57/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_93SE0_450yn7sPyMOAOBXpYneEIaFLppjHnjpEBpRhDs_JUMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-11-05_17_57/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-11-05_17_57/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-11-05_17_57/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-11-05_17_57/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-11-05_17_57/pages/registration.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-11-05_17_57/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-11-05_17_57/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-11-05_17_57/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-11-05_17_57/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-11-05_17_57/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-11-05_17_57/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthdayJGu3lPMjGezzqWeZvD6gFdiUvS8qMnMkvcJyUzlLXEcMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: manageAZXhvMsiSz2JACwIZKKhr4KgsszXRsuPH8Pe_sht0xUMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/auth.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-11-05_17_57/pages/tariffs/index.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-11-05_17_57/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-11-05_17_57/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffsmnGWn60AGjcNruz__a7RPNuqCucZFy_45G4Nu846w47pYMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-11-05_17_57/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: indexYnOXJCPo6UEUS8xWDYqKFEMYIxF_TJhFWfC5A_45b10VoMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-11-05_17_57/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-11-05_17_57/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-11-05_17_57/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-11-05_17_57/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-11-05_17_57/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-11-05_17_57/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-11-05_17_57/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importN_6Ta_45xMluZdXPD2H9ykl_dQeuCNV6A91_LcXn__45tkgMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logoutUczFkPz_45YuqY5yyEAmGN13qBn6upmkVRbp0u1jp1yQYMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-11-05_17_57/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-11-05_17_57/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear20241gT9ibkMa28Z6Npx4S9yj_45eOaYn6CyuDUnRSyo_45WadAMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozonPO7cwHH8_45y_GJi6y10wDO7_bTGB1Vf6lnzHnpz_45xdsAMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-11-05_17_57/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: accountaRLh7kWWFMrz5QD7UOwH3Ln2zQMEFR0zVdMug2QvQckMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-11-05_17_57/pages/prohibited-goods.vue")
  },
  {
    name: "survey-completed",
    path: "/survey-completed",
    meta: survey_45completedwAB7qepLmw5Mr9TnHVwoBUn2bfY6jUgDlOU_45yiuklzYMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/survey-completed.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-11-05_17_57/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-11-05_17_57/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-11-05_17_57/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculatorQpU3JMQwH9rSOb0CEpQsA6Ly_cSV1GrAjlbRVWbdNOcMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-11-05_17_57/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-11-05_17_57/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-11-05_17_57/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discount10LXy0xTiQMDRx7d1riXYwr3MCUleqcp01NVJQiYpkoMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-11-05_17_57/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-11-05_17_57/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient10201917GeBxoP26__2pcxvJmmBbjjH2Lna7SmYcxNfHzoSD4BUMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-11-05_17_57/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: indexXVZZE6X5rIUqFdgu6R5xgDBWNgL20A0H_45otHbOdrL9wMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/order/create/index.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-11-05_17_57/pages/run-schedule/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/sofa.vue")
  },
  {
    name: "tariffs-location",
    path: "/tariffs/:location()",
    component: () => import("/var/www/2025-11-05_17_57/pages/tariffs/[location].vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-11-05_17_57/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodesdrHadFbMVTSPiJJ2ZDq1GzEImuvet_WJLumG4cFhRB4Meta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-11-05_17_57/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_93AeJELEAj5taPbSHhWiWycomPvUQawSaOJKB4RUkDoccMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: printgSP_w_45Qvyog6MlaS0UjP0FybH2DHS8Q_45swHL9bih_ogMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-11-05_17_57/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-11-05_17_57/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-11-05_17_57/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_93gRswOzy6pFrGP29UkF15ouPDmHKCHMkwvqaYIk9HFjcMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: createWp3nxuXntzpKfDk3J5IwrThE2bdgmuNk_45wRYoNACO54Meta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/order/create.vue")
  },
  {
    name: "safekeep-create",
    path: "/safekeep/create",
    meta: indexPLc4XDTGg0JioeoosPhLrGniHKNndyeEJ1lCgEd807EMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/safekeep/create/index.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-11-05_17_57/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-11-05_17_57/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-11-05_17_57/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberries4vJj4UaUufE8HKKSUfG3SyIbjv_5t5qPZU84VK8bLG4Meta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-11-05_17_57/pages/order/administer/[guid].vue")
  },
  {
    name: "run-schedule-location",
    path: "/run-schedule/:location()",
    component: () => import("/var/www/2025-11-05_17_57/pages/run-schedule/[location].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-11-05_17_57/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_93pUy98kAZZqImCY_fK43WSUkOvW2lJaeTaET1MQ7qD6sMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/orders/[...tab].vue")
  },
  {
    name: "personal-safekeep-guid",
    path: "/personal/safekeep/:tag(pay)?/:guid",
    meta: _91guid_93FODlO_PvSA7wPQNO4aJTnRkJJ3xGxnfl4ziXgnPHeZ0Meta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/safekeep/[guid].vue")
  },
  {
    name: "personal-safekeep-create",
    path: "/personal/safekeep/create",
    meta: createifsqgYJPjQlfUuoChTVzWlLVjFqUWFzgL1xZdU9PCn4Meta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/safekeep/create.vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: indexwqLPSXH8w9FkCKFfdEpRh4RpkKlEUEE_45UOORKUT8lEwMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45marketSVsdbhA2dg7_FIthJuS5JJ3CTG3M6UbtAO4YsVcsOI8Meta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templatesRHTLps1ellWj9i2ssOgmSs8ZFtkZQ6PE922xWK5LSJsMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: index7WdNMOk04aJcUAXVFeoqt6PFadnZUbswLYF1dSQeHcoMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/contractors/index.vue")
  },
  {
    name: "personal-order-ozon-guid",
    path: "/personal/order-ozon/:guid",
    meta: _91guid_93gMBGkfgucQ3iri1wJ7jU3hv96tEDanfcMDUjlHv8HzgMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/order-ozon/[guid].vue")
  },
  {
    name: "safekeep-administer-guid",
    path: "/safekeep/administer/:guid()",
    component: () => import("/var/www/2025-11-05_17_57/pages/safekeep/administer/[guid].vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93ugRuNCDRdrbg74j9Gz4bsuacO9I_wL9K6v1TCHESGWoMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: indexBjbBki_45NPymKRphf1IGdrVbVeDfgMQWZFvrMcmjILcEMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-safekeeps-tab",
    path: "/personal/safekeeps/:tab(.*)*",
    meta: _91_46_46_46tab_93X_KAcsaZS8pB4MjNhgTP1CiEQeE1RWPBxkF0YKQFT4cMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/safekeeps/[...tab].vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_93IjbKXcY0cEGAlO7sgdwJJe7aZOXIc_uhQVhwiV0to7QMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: indexvDWH3gFaaZAMZK47RvmtI8dHvf6cimCZ1VpLz5NFbSYMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: index_4553FyWRGgu_V9ZDulbFucgiwaTG656MHWbxTKgxanz0Meta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "personal-orders-ozon-tab",
    path: "/personal/orders-ozon/:tab(.*)*",
    meta: _91_46_46_46tab_93RaQpApDOzLGsSI0RXIZEg_DyUmBQg9vMQzhxEbsg5HgMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/orders-ozon/[...tab].vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_93_459dCjMdkxZe3H7X8MTw3aqdkZ9raPFXyhtz_oyXGE6sMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93THHeGYbIlF8CfsiBFKOV9oz4AqOV_tTZIGOV8sH_45uYEMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_93QhdhzWNw7x02AjQimgRgaKbX3LT9dSCjUq1lFu9biyMMeta || {},
    component: () => import("/var/www/2025-11-05_17_57/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-11-05_17_57/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-11-05_17_57/pages/shippingtypes/personalitemstransportation.vue")
  }
]